import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  Divider,
  FormFieldSet,
  LogoLoader,
  Modal,
  PageHeader,
  PageTitle,
  showToast,
  useFormHandler,
  AttachmentSection,
  DocumentsList,
} from "../../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { countryOptions } from "../../../../../../assets/data/projectData";
import { PassportStatus } from "../../../../../../assets/data/enumData";
//////
import { useDispatch, useSelector } from "react-redux";
import {
  getEmployeeByUiidStart,
  updateEmployeeStart,
} from "../../../../../../redux/slices/employee/employeeSlice";

//Get Login User data
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import { addDocumentStart } from "../../../../../../redux/slices/universal/documentsSlice";
import { transformFiles } from "../../../../../../utils/transformFiles";
//Get Login User data end

const PassportModal = ({ isOpen, onClose, edit, selectedRow }) => {
  const dispatch = useDispatch();
  const [validationRules, setValidationRules] = useState({});
  const { employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );

  const { uiid: employeeUiid, passport } =
    currentEmployee.employeeDetails || {};

  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;

  const initialFormData = {
    passportNumber: "",
    status: "",
    placeOfIssue: "",
    placeOfBirth: "",
    issuedDate: "",
    expiryDate: "",
    issuingCountry: "",
    attachments: [
      {
        id: uuidv4(),
        // attachmentName: "",
        // attachmentComments: "",
        chooseFiles: [],
      },
    ],
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);
  useEffect(() => {
    const baseRules = {
      passportNumber: { type: "text", required: true },
      status: { type: "select", required: true },
      placeOfIssue: { type: "text", required: true },
      placeOfBirth: { type: "text", required: true },
      issuedDate: { type: "date", required: true },
      expiryDate: { type: "date", required: true },
      issuingCountry: { type: "select", required: true },
      attachments: [{ chooseFiles: { type: "file" } }],
    };
    setValidationRules(baseRules);
  }, [formData.attachments.length]);

  ///////////////////////////////////////////////////
  //handel Attachment Error
  ///////////////////////////////////////////////////

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };
  ///////////////////////////////////////////////////
  //handel Attachment Error end
  ///////////////////////////////////////////////////

  ///////////////////Handel Save//////////////////////
  const handleSavePassport = () => {
    const isValid = validateAllFields();

    if (isValid) {
      const userFormData = {
        number: formData.passportNumber,
        issuedAt: formData.issuingCountry.value,
        issueDate: formData.issuedDate,
        expiryDate: formData.expiryDate,
        birthPlace: formData.placeOfBirth,
        country: formData.placeOfIssue,
        status: formData.status,
      };

      const submissionData = filterEmptyValues(userFormData);
      const cleanAttachments = formData.attachments.filter(
        (att) =>
          att.attachmentName.trim() !== "" ||
          att.attachmentComments.trim() !== "" ||
          (att.chooseFiles && att.chooseFiles.length > 0),
      );

      dispatch(
        updateEmployeeStart({
          coll: "Employee",
          uiid: employeeProfileUiid,
          tab: "passportTab",
          ret: "passport",
          tPath: edit ? "" : "passport",
          patchId: edit ? selectedRow?._id : "",
          payload: [
            {
              type: edit ? "SET" : "PUSH",
              value: {
                [edit ? "passport.$[elem]" : "passport"]: submissionData,
              },
              // value: {edit?"passport.$[elem]":submissionData :passport: submissionData },
            },
          ],
          onSuccess: async (payload) => {
            if (cleanAttachments?.length) {
              dispatch(
                uploadStart({
                  uploadType: "multiple",
                  field: "doc",
                  uiid: employeeProfileUiid,
                  entity: "employees",
                  category: "passport",
                  coll: "Employee", //WorkAuth

                  doc: cleanAttachments.flatMap((doc) =>
                    doc.chooseFiles.map((file) => {
                      file.id = doc.id;
                      return file;
                    }),
                  ),
                  onSuccess: async (fileData) => {
                    // fileData response will be array format, since uploadType: "multiple"
                    dispatch(
                      // addDocumentStart({
                      //   coll: "Document",
                      //   refColl: "Employee",
                      //   refId: employeeProfileUiid,
                      //   // refField: "passport.documents",
                      //   refField: "passport.$[elem].documents",
                      //   refPatchId: edit
                      //     ? selectedRow?._id
                      //     : payload?.data?.targetPatchId,
                      //   payload: {
                      //     addedBy: loginUserUiid,
                      //     attachments: cleanAttachments.map((obj) => ({
                      //       addedBy: loginUserUiid,
                      //       name: obj.attachmentName,
                      //       comments: obj.attachmentComments,
                      //       filePath: fileData.find(
                      //         (file) => file.fileRefId === obj.id
                      //       ).url,
                      //     })),
                      //   },
                      //   //onSuccess: handleModalClose,
                      //   onSuccess: async () => {
                      //     dispatch(
                      //       getEmployeeByUiidStart({
                      //         uiid: employeeProfileUiid,
                      //         tab: "passportTab",
                      //         ret: "passport",
                      //         ref: "passportDoc",
                      //       })
                      //     );
                      //     handleModalClose();
                      //   },
                      // })
                      addDocumentStart({
                        coll: "Document",
                        refColl: "Employee",
                        refId: employeeProfileUiid,
                        // refField: "passport.documents",
                        refField: "passport.$[elem].documents",
                        refPatchId: edit
                          ? selectedRow?._id
                          : payload?.data?.targetPatchId,
                        payload: {
                          addedBy: loginUserUiid,
                          attachments: [
                            {
                              docType: "Passport",
                              parent: { employee: employeeProfileUiid },
                              addedBy: loginUserUiid,
                              ref: {
                                id: employeeProfileUiid,
                                entity: "Employee", // collection name this doc belongs to
                                path: `passport.${
                                  edit
                                    ? selectedRow?._id
                                    : payload?.data?.targetPatchId
                                }.documents`,
                              },
                              file: cleanAttachments.map((obj) => ({
                                name: obj.attachmentName,
                                comments: obj.attachmentComments,
                                keys: fileData
                                  .filter(
                                    (file) =>
                                      file?.fileRefId === obj.id && file.key,
                                  ) // match and ensure key exists
                                  .map((file) => file.key),
                              })),
                            },
                          ],
                        },
                        //onSuccess: handleModalClose,
                        onSuccess: async () => {
                          dispatch(
                            getEmployeeByUiidStart({
                              uiid: employeeProfileUiid,
                              tab: "passportTab",
                              ret: "passport",
                              ref: "passportDoc",
                            }),
                          );
                          handleModalClose();
                        },
                      }),
                    );
                  },
                }),
              );
            } else {
              dispatch(
                getEmployeeByUiidStart({
                  uiid: employeeProfileUiid,
                  tab: "passportTab",
                  ret: "passport",
                  ref: "passportDoc",
                }),
              );
              handleModalClose();
            }
          },
        }),
      );
    } else {
      showToast("Please fill in all the required fields before saving.", "error");
    }
  };
  ///////////////////handel save end////////////////////

  const handleModalClose = () => {
    onClose(true);
    setFormData(initialFormData);
  };
  useEffect(() => {
    if (edit) {
      handleChange("passportNumber", selectedRow?.number);
      handleChange("issuingCountry", selectedRow?.issuedAt);
      handleChange("issuedDate", selectedRow?.issueDate);
      handleChange("expiryDate", selectedRow?.expiryDate);
      handleChange("placeOfBirth", selectedRow?.birthPlace);
      handleChange("placeOfIssue", selectedRow?.country);
      handleChange("status", selectedRow?.status);
    } else {
      setFormData(initialFormData);
    }
  }, [edit, selectedRow]);
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleModalClose}
      title={edit ? "Edit Passport Details" : "Add Passport"}
      width="max-w-7xl"
    >
      <div className="">
        {/* <div className="grid grid-cols-3 gap-x-6 gap-y-6 px-2 max-w-7xl"> */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4 max-w-7xl">
          <FormFieldSet
            type="text"
            title="Passport Number"
            placeholder="Enter Passport Number"
            value={formData.passportNumber}
            onChange={(value) => handleChange("passportNumber", value)}
            error={errors.passportNumber}
          />
          <FormFieldSet
            type="select"
            title="Status"
            placeholder="Select Status"
            options={PassportStatus}
            value={formData.status}
            onChange={(value) => handleChange("status", value)}
            error={errors.status}
          />
          <FormFieldSet
            type="text"
            title="Place of Issue"
            placeholder="Enter Place of Issue"
            value={formData.placeOfIssue}
            onChange={(value) => handleChange("placeOfIssue", value)}
            error={errors.placeOfIssue}
          />
          <FormFieldSet
            type="text"
            title="Place of Birth"
            placeholder="Enter Place of Birth"
            value={formData.placeOfBirth}
            onChange={(value) => handleChange("placeOfBirth", value)}
            error={errors.placeOfBirth}
          />
          <FormFieldSet
            type="datepicker"
            title="Issued Date"
            placeholder="Select Issued Date"
            value={formData.issuedDate}
            onChange={(value) => handleChange("issuedDate", value)}
            error={errors.issuedDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title="Expiry Date"
            placeholder="Select Expiry Date"
            value={formData.expiryDate}
            onChange={(value) => handleChange("expiryDate", value)}
            error={errors.expiryDate}
            showDropdown={false}
          />
          <FormFieldSet
            // type="select"
            type="countries"
            title="Issuing Country"
            keyname="countries"
            showSearch
            placeholder="Select Issuing Country"
            // options={countryOptions}
            value={formData.issuingCountry}
            onChange={(value) => handleChange("issuingCountry", value)}
            error={errors.issuingCountry}
          />
        </div>

        <div className="mt-4 mb-1">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title="Attachments" tag="h6" />
              </div>
            }
          />
        </div>
        <Divider />
        {edit && <div></div>}
        {edit && (
          <DocumentsList
            data={transformFiles(selectedRow?.documents || [])}
            type="inner"
          />
        )}
        <AttachmentSection
          attachments={formData.attachments}
          onChange={(newAttachments) =>
            setFormData({ ...formData, attachments: newAttachments })
          }
          getAttachmentError={getAttachmentError}
          showNameField={true}
          showCommentsField={true}
        />

        <div className="flex gap-3 justify-end my-6">
          <Button
            title="Cancel"
            variant="outlined"
            onClick={handleModalClose}
          />
          <Button title="Save" onClick={handleSavePassport} />
        </div>
      </div>
      <Backdrop isOpen={false}>
        <LogoLoader />
      </Backdrop>
    </Modal>
  );
};

export default PassportModal;
